import { DataGrid } from "devextreme-react";
import { Button, Column } from "devextreme-react/data-grid";
import * as React from "react";
import { useCallback } from "react";
import { IVisitatieRapportPrestatieItem, IZoekPrestatiesModel } from "../models/IZoekPrestatiesResponse";

interface IProps {
    item: IZoekPrestatiesModel
}


const PrestatiesDoelstellingItem = ({ item }: IProps) => {

    //const ds = useListSource<IVisitatieRapport>(item.visitatierapporten)

    const openDoc = useCallback((e: { column: any, row: { data: IVisitatieRapportPrestatieItem } }) => {
        //console.log(e);
        document.location = e.row.data.documentLink;
    }, [])

    return <div className="prestatieItem">
        <h3 className='bullet'>{item.operationeleDoelstelling} <small>(aantal: {item.visitatierapporten.length})</small></h3>
        <DataGrid<IVisitatieRapportPrestatieItem, number>
            dataSource={item.visitatierapporten}
            hoverStateEnabled
            //rowAlternationEnabled
            showRowLines
        >
            <Column dataField="jaar" width="auto" />
            <Column dataField="shmNaam" />
            <Column dataField="activiteit" width={120} />
            <Column dataField="visitatieronde" width={120}/>
            {/*<Column dataField="documentLink" />*/}
            <Column dataField="score" width={90} />
            <Column type="buttons" width={50}>                
                <Button hint="Visitatierapport openen" icon="download" onClick={openDoc} />
            </Column>
        </DataGrid>
    </div>;
}
export default PrestatiesDoelstellingItem;